"use client";
import { useState, useRef, useEffect, useCallback } from "react";


export default function TrashIcon({ style, className = "" }) {
  const [position, setPosition] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  const elementRef = useRef(null);

  const handleMouseDown = useCallback((e) => {
    if (e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    const rect = elementRef.current?.getBoundingClientRect();
    if (rect) {
      dragOffset.current = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
      if (!position) {
        const parentRect = elementRef.current.offsetParent?.getBoundingClientRect() || { left: 0, top: 0 };
        setPosition({
          x: rect.left - parentRect.left,
          y: rect.top - parentRect.top,
        });
      }
    }
    setIsDragging(true);
  }, [position]);

  const handleMouseMove = useCallback((e) => {
    if (!isDragging || !elementRef.current) return;
    const parentRect = elementRef.current.offsetParent?.getBoundingClientRect() || { left: 0, top: 0 };
    setPosition({
      x: e.clientX - parentRect.left - dragOffset.current.x,
      y: e.clientY - parentRect.top - dragOffset.current.y,
    });
  }, [isDragging]);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  const positionStyle = position
    ? { position: "absolute", left: position.x, top: position.y }
    : {};
  return (
    <div
      ref={elementRef}
      className={`flex flex-col items-center gap-0 cursor-grab select-none ${isDragging ? "cursor-grabbing z-50" : ""} ${className}`}
      style={{
        ...style,
        ...positionStyle,
        width: 59,
      }}
      onMouseDown={handleMouseDown}
      // onClick={(e) => {
      //   if (!isDragging && onClick) onClick(e);
      // }}
      draggable={false}
    >
      <div className="w-[59px] h-[59px] relative flex-shrink-0">
        <img
          src="https://framerusercontent.com/images/AbIAp0qW5rYTqOKWfx9xlOy8Pio.png?scale-down-to=512"
          alt="Trash"
          className="w-full h-full object-contain"
        />
      </div>
      <p
        className="whitespace-nowrap text-center text-[13.5px]"
        style={{
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
          fontWeight: 500,
          color: "#000",
        }}
      >
        Trash
      </p>
    </div>
  );
}
